import reactComponentLoader from 'scripts/react-component-loader'

import { LandingPage } from '../LandingPage'

reactComponentLoader(LandingPage, '[data-lmcv-landing-page]')
